<template>
    <v-hover v-slot="{ hover }">
      <v-card
        class="video-card"
        :elevation="hover ? 12 : 4"
      >
        <div class="thumbnail-container">
          <v-img
            :src="video.thumbnail"
            aspect-ratio="1.78"
            class="align-end"
            gradient="to top, rgba(0,0,0,0.7), rgba(0,0,0,0.3)"
          >
            <v-icon
              x-large
              color="white"
              class="play-button"
              :class="{ 'scale-up': hover }"
            >
              mdi-play-circle-outline
            </v-icon>
            
            <div class="duration-label">
              {{ formatDuration(video.duration) }}
            </div>
          </v-img>
        </div>
        
        <v-card-text class="py-3">
 Ajouter des protections contre les valeurs nulles
        <h3 class="text-h6 font-weight-bold mb-2 truncate">
            {{ video?.title || 'Titre non disponible' }}
          </h3>
          
          <div class="d-flex justify-space-between text-caption">
            <span>{{ video?.uploadedAt || 'Date inconnue' }}</span>
            <span>{{ (video?.views || 0) }} vues</span>
          </div>
        </v-card-text>
      </v-card>
    </v-hover>
  </template>

<script>
  export default {
    props: {
      video: {
        type: Object,
        required: true
      }
    },
  
    methods: {
      formatDuration(seconds) {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
      }
    }
  }
  </script>
  
  <style scoped>
  .duration-label {
    position: absolute;
    bottom: 8px;
    right: 8px;
    background: rgba(0,0,0,0.7);
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.8em;
  }
  
  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  </style>
  